import { Component } from '@angular/core';

@Component({
  selector: 'atlas-panel-title',
  templateUrl: './panel-title.component.html',
  styleUrls: ['./panel-title.component.scss'],
  standalone: false,
})
export class PanelTitleComponent {}
